import { MouseEvent } from "react";

export interface IExpander {
  /** Defines it is expanded or collapsed */
  expanded?: boolean;
  /** Applies passed styles */
  style?: object;
  /** Applies passed classes */
  className?: string;
  /** Click callback */
  onClick?: (event: MouseEvent<SVGSVGElement>) => void;
}
